import { Vue, Component, State, namespace, Prop } from 'nuxt-property-decorator'
import CategoryTree from '~/components/experience/destinations-category-tree/category-tree.vue'
import RangesTree from '~/components/experience/destinations-category-tree/ranges-tree.vue'
import ModalTree from '~/components/experience/destinations-category-tree/modal-tree.vue'
import { Experience } from '~/types/experience'

import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component({
  components: {
    CategoryTree, RangesTree, ModalTree
  }
})

export default class TreeModel extends Vue {
  @State klook!: Data.Klook
  @experience.Action setUrlQuery!: Function
  @experience.Action setSelectedCategory!: Function
  @experience.Action setSelectedRanges!: Function
  @experience.State urlQuery!: UrlQuery
  @experience.State pageType!: string

  @Prop() type!: 'range' | 'category'
  visible: boolean = false
  selectedRange: any = []
  selectedCategory: any = []
  clearDisable: boolean = true
  hasChange: boolean = false

  get spmModule() {
    const o = {
      country_id: this.urlQuery.country_ids,
      city_id: this.urlQuery.city_ids
    }
    const category = this.urlQuery.frontend_id_list || ''
    const spm = this.type === 'range'
      ? `ConfirmDestination?trg=manual&ext=${JSON.stringify(o)}`
      : `ConfirmCategory?trg=manual&ext=${JSON.stringify({ categorytree_id: category })}`
    return spm
  }

  closeModal() {
    this.visible = false
    const t = setTimeout(() => {
      this.$emit('close')
      clearTimeout(t)
    }, 300)
  }

  rangeChange(data: any) {
    this.hasChange = true
    this.selectedRange = data
    this.initClearDisableStatus()
  }

  categoryChange(data: any) {
    this.hasChange = true
    this.selectedCategory = data
    this.initClearDisableStatus()
  }

  formatRange() {
    const range = Object.keys(this.selectedRange.rangeId || []).join(',')
    const country = Object.keys(this.selectedRange.countryId || []).join(',')
    const city = Object.keys(this.selectedRange.cityId || []).join(',')
    return {
      range,
      country,
      city
    }
  }

  formatCategory() {
    return Object.keys(this.selectedCategory || []).join(',')
  }

  beforeConfirm() {
    if (this.type === 'range') {
      this.setSelectedRanges(JSON.parse(JSON.stringify(this.selectedRange)))
      const d = this.formatRange()
      return {
        range_id: d.range,
        country_ids: d.country,
        city_ids: d.city,
        page: 1
      }
    } else if (this.type === 'category') {
      this.setSelectedCategory(JSON.parse(JSON.stringify(this.selectedCategory)))
      return {
        frontend_id_list: this.formatCategory(),
        page: 1
      }
    }
  }

  onConfirm() {
    if (this.hasChange) {
      const p = this.beforeConfirm()
      this.setUrlQuery(p)
    }
    this.closeModal()
  }

  initClearDisableStatus() {
    if (this.type === 'range') {
      const range = this.formatRange()
      const r = range.city + range.country
      this.clearDisable = !r
    }
    if (this.type === 'category') {
      const category = this.formatCategory()
      this.clearDisable = !category
    }
  }

  mounted() {
    this.visible = true
    if (this.type === 'range') {
      const city = (this.urlQuery.city_ids || '')
      const country = (this.urlQuery.country_ids || '')
      this.clearDisable = !(city + country)
    } else {
      const category = (this.urlQuery.frontend_id_list || '')
      this.clearDisable = !(category)
    }
  }
}
